
<div
  tabindex="0"
  :data-id="objectModelTrigger.client_id"
  :data-type="objectModelTrigger.trigger_type"
  class="form-element"
  :class="propertyClasses"
  @focus="replaceIdInRoute"
  @click.stop="replaceIdInRoute">
  <row class="title-bar">
     <prefix>
        <span class="tag-icon" :class="ObjectModelTriggerDefinition.getIconColor(objectModelTrigger.trigger_type)">
          <icon :class="ObjectModelTriggerDefinition.getIcon(objectModelTrigger.trigger_type)"></icon>
        </span>
      </prefix>
      <column>
        <strong class="title">
          {{ObjectModelTriggerDefinition.getDisplayName(objectModelTrigger.trigger_type)}}
        </strong>
      </column>
      <move-destroy v-if="isMoveDestroyable"
                  :card="objectModelTrigger"
                  @remove:card="remove"
                  class="suffix"
    ></move-destroy>
      <suffix v-else>
        <icon class="locked"></icon>
        <span class="sr-only">Trigger Locked</span>
      </suffix>
  </row>
  <row class="component-row">
    <column v-if="objectModelTrigger.can(ObjectModelTriggerCapability.labelable)">
      <object-model-trigger-labelable
        :object-model-trigger="objectModelTrigger"></object-model-trigger-labelable>
    </column>
    <suffix>
      <button class="relative-container">
        <icon :class="[objectModelTrigger.notificationsArray.length > 0 ? 'notification-on' : 'notification-off']"></icon>
        <span class="notification-count">{{objectModelTrigger.notificationsArray.length}}</span>
        <span class="sr-only">Notification Bell Button</span>
      </button>&nbsp;
    </suffix>
  </row>

  <component
    :is="getComponentByType(objectModelTrigger.trigger_type)"
    :object-model-trigger="objectModelTrigger"
    @remove="remove"></component>

  <template v-if="objectModelTrigger.first_trigger.type === DurationType.propertyBasedTimeSpan">
    <p class="small">
      When it is {{
      `${objectModelTrigger.first_trigger.amount}
      ${durationUnitLabelFor(objectModelTrigger.first_trigger.unit)}
      ${comparisonLabelFor(objectModelTrigger.first_trigger.comparison)} ${objectModelPropertyLabel ? objectModelPropertyLabel + "," : ''}`}}
    </p>
  </template>
  <template v-if="objectModelTrigger.first_trigger.type === DurationType.datePicker">
    <p class="small">
      On {{triggerStartDate}}{{objectModelTrigger.occurs_at_interval ? "," : ""}}
    </p>
  </template>
  <template v-if="objectModelTrigger.occurs_at_interval">
    <p class="small">
      <interval-display :interval="objectModelTrigger.interval">
      </interval-display>
    </p>
  </template>
  <template v-if="objectModelTrigger.trigger_based_on_type === ObjectModelTriggerBasedOnType.ObjectModelProperty">
    <p class="small">
      <template v-for="(ruleSet, index) in objectModelTrigger.getSortedConditionalRuleSets('trigger')">
        <conditional-display-rule
          :key="`${ruleSet.client_id}`"
          :class="{ 'condition-rule': true }"
          :conditional-rule-set="ruleSet"
          :totalRuleSets="Object.keys(objectModelTrigger.trigger_conditional_rule_sets).length"
          hideControls
          :disabled="true">
        </conditional-display-rule>
        <slot name="value" :uniqueId="index" :model="ruleSet" fieldName="conditional_value"></slot>
      </template>
    </p>
  </template>
</div>
